class RealTimeStock {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="RealTimeStock"]'),
      lang: document.documentElement.lang || 'nl',
      minAmount: 10,
      ...options
    };
  }

  static getStockStates(module) {
    return {
      available: {
        stateClass: 'is-available',
        text: module.dataset.availableText,
        tooltip: module.dataset.availableTooltip
      },
      'not-available': {
        stateClass: 'is-not-available',
        text: module.dataset.notAvailableText,
        tooltip: module.dataset.notAvailableTooltip
      },
      limited: {
        stateClass: 'is-limited',
        text: module.dataset.limitedText,
        tooltip: module.dataset.limitedTooltip
      }
    };
  }

  init() {
    const { moduleList, lang, minAmount } = this.config;

    moduleList.forEach(module => {
      const { productId, errorMessage } = module.dataset;
      const container = module.querySelector('[data-module-child="Container"]');
      const indicator = module.querySelector('[data-module-child="Indicator"]');
      const text = module.querySelector('[data-module-child="Text"]');
      const stockStates = RealTimeStock.getStockStates(module);

      if (productId && container && indicator && text) {
        // const incrementer = document.querySelector(
        //   `[data-module="incrementer"][data-productId="${productId}"]`
        // );
        // const cartButton = document.querySelector(
        //   `[data-module="order-product"][data-productId="${productId}"]`
        // );

        // if (incrementer) {
        //   incrementer.classList.add('is-disabled');
        // }

        // if (cartButton) {
        //   cartButton.setAttribute('disabled', 'true');
        // }

        module.classList.add('is-loading');

        fetch(`/api/v2/catalog/product/${productId}/stock`, {
          method: 'GET',
          headers: {
            'Accept-Language': lang
          }
        })
          .then(res => res.json())
          .then(json => {
            const { isInStock, amountInStock } = json;
            let stateKey = '';

            // if (cartButton) {
            //   cartButton.removeAttribute('disabled');
            // }

            if (isInStock) {
              stateKey = amountInStock >= minAmount ? 'available' : 'limited';

              // if (incrementer) {
              //   incrementer.classList.remove('is-disabled');
              // }
            } else {
              stateKey = 'not-available';
            }

            indicator.classList.add('data-tooltip', stockStates[stateKey].stateClass);
            indicator.setAttribute('data-tooltip', stockStates[stateKey].tooltip);
            text.appendChild(document.createTextNode(stockStates[stateKey].text));
            module.classList.remove('is-loading');
            container.classList.remove('hidden');
          })
          .catch(() => {
            module.classList.add('is-error');
            module.appendChild(document.createTextNode(errorMessage || 'Stock not available'));
            module.classList.remove('is-loading');
            container.classList.remove('hidden');
          });
      }
    });
  }
}

export default RealTimeStock;
